;(function () {
  'use strict'

  angular.module('contrast.attacks').constant('ATTACK_EVENT_TYPE', {
    BOT_BLOCKER: 'BB',
    IP_BLACKLIST: 'IP',
    PROTECT_RULE: 'PR',
    VIRTUAL_PATCH: 'VP'
  })
})()
